import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTextField } from '@react-aria/textfield';
import { forwardRef, Fragment, useRef, useState } from 'react';
import { isBoolean, isFormValidationErrorDisplayed } from '../../common.types.js';
import { mergeRefs } from '../BKJSelect/utils/mergeRefs.js';
import { Input, InputErrorMessage, InputLabel, RequiredAsterisk, TextInputWrapper, WordCount, } from './BKJTextArea.styled.js';
export const BKJTextArea = forwardRef((props, ref) => {
    const { label, error, maxLength = 500, required, disabled, onChange, className, width, height, ...rest } = props;
    const innerRef = useRef({});
    const hasStringyError = isFormValidationErrorDisplayed(error) && !isBoolean(error);
    const { labelProps, inputProps, errorMessageProps } = useTextField({
        label: label || 'Text area',
        isRequired: required,
        isDisabled: disabled,
        inputElementType: 'textarea',
        errorMessage: hasStringyError ? error : undefined,
        validationState: isFormValidationErrorDisplayed(error) ? 'invalid' : 'valid',
    }, innerRef);
    const [charCount, setCharCount] = useState(props.value ? props.value.toLocaleString().length : 0);
    const countChars = (e) => {
        const text = e.target.value;
        setCharCount(text.length);
    };
    const handleChange = (e) => {
        if (onChange)
            onChange(e);
        countChars(e);
    };
    return (_jsxs(TextInputWrapper, { className: className, children: [label && (_jsxs(InputLabel, { ...labelProps, disabled: disabled, children: [label, " ", required && _jsx(RequiredAsterisk, { children: "\u00A0*" })] })), _jsx(Input, { ...inputProps, ref: mergeRefs([innerRef, ref]), error: !!error, onChange: handleChange, maxLength: maxLength, disabled: disabled, width: width, height: height, value: props.value, ...rest }), _jsxs(WordCount, { disabled: disabled, error: error ? (Array.isArray(error) ? !!error.length : !!error) : false, children: [`${charCount}/${maxLength}`, hasStringyError && (_jsx(InputErrorMessage, { ...errorMessageProps, children: Array.isArray(error)
                            ? error.map((err, i) => (_jsxs(Fragment, { children: [i > 0 && _jsx("br", {}), err] }, `${err}-${i}`)))
                            : error }))] })] }));
});
//# sourceMappingURL=BKJTextArea.js.map